var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgF4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 30,
    fill: "#EFF3FD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.5 27.5H17.5M42.5 28.75V25.25C42.5 23.8499 42.5 23.1498 42.2275 22.615C41.9878 22.1446 41.6054 21.7622 41.135 21.5225C40.6002 21.25 39.9001 21.25 38.5 21.25H21.5C20.0999 21.25 19.3998 21.25 18.865 21.5225C18.3946 21.7622 18.0122 22.1446 17.7725 22.615C17.5 23.1498 17.5 23.8499 17.5 25.25V34.75C17.5 36.1501 17.5 36.8502 17.7725 37.385C18.0122 37.8554 18.3946 38.2378 18.865 38.4775C19.3998 38.75 20.0999 38.75 21.5 38.75H29.375M37.5 41.25C37.5 41.25 41.25 39.4626 41.25 36.7815V33.6536L38.5155 32.6765C37.8585 32.4412 37.14 32.4412 36.483 32.6765L33.75 33.6536V36.7815C33.75 39.4626 37.5 41.25 37.5 41.25Z",
    stroke: "#3375B9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgF4);
export default __webpack_public_path__ + "static/media/f4.a8ae4e81b2b25a57a55591962059aaad.svg";
export { ForwardRef as ReactComponent };